
import { Vue, Component, Prop } from 'vue-property-decorator';
import VoteButton from './VoteButtonNew.vue';

import { Icon, Lazyload } from 'vant';

Vue.use(Icon).use(Lazyload);
@Component({
  components: {
    VoteButton,
  },
})
export default class Item extends Vue {
  @Prop() item!: any;
  @Prop() index!: any;
  voteNameCase: string = '2024project/q1/2024dlhmxc';

  votSuccess(data: any) {
    console.log('data:', data);
    this.item.votes = data;
    this.$emit('votSuccess', data);
  }
}
